
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contattaci",
      function () {
        return require("private-next-pages/contattaci/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contattaci"])
      });
    }
  